function Contact() {
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const data = new FormData(form);

    fetch("/", {
      method: "POST",
      body: data,
    })
      .then(() => {
        alert("Message sent!");
        form.reset();
      })
      .catch((error) => {
        alert("Error submitting the form");
      });
  };
  return (
    <section class="py-5">
      <div class="container px-5">
        <div class="bg-light rounded-4 py-5 px-4 px-md-5">
          <div class="text-center mb-5">
            <div class="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 mb-3">
              <i class="bi bi-envelope"></i>
            </div>
            <h1 class="fw-bolder">Get in touch</h1>
            <p class="lead fw-normal text-muted mb-0">Let's work together!</p>
          </div>
          <div class="row gx-5 justify-content-center">
            <div class="col-lg-8 col-xl-6">
              <form
                name="contact"
                method="POST"
                data-netlify="true"
                onSubmit={handleSubmit}
              >
                <input type="hidden" name="form-name" value="contact" />

                <div class="form-floating mb-3">
                  <input
                    class="form-control"
                    id="name"
                    type="text"
                    name="name"
                  />
                  <label for="name">Full name</label>
                </div>

                <div class="form-floating mb-3">
                  <input
                    class="form-control"
                    id="email"
                    type="email"
                    name="email"
                  />
                  <label for="email">Email address</label>
                </div>

                <div class="form-floating mb-3">
                  <input
                    class="form-control"
                    id="phone"
                    type="tel"
                    name="phone"
                  />
                  <label for="phone">Phone number</label>
                </div>

                <div class="form-floating mb-3">
                  <textarea
                    class="form-control"
                    id="message"
                    name="message"
                    style={{ height: "10vh" }}
                  />
                  <label for="message">Message</label>
                </div>

                <div class="d-grid">
                  <button class="btn btn-primary btn-lg" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
